import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Icon } from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: 8
    },
    rootSmall: {
        width: 75,
        height: 75
    },
    rootLarge: {
        width: 175,
        height: 175,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            height: 135
        }
    },
    iconSmall: { fontSize: 50, width: "auto" },
    iconLarge: { fontSize: 112, width: "auto" },
    img: {
        margin: "auto",
        display: "block",
        maxWidth: "100%",
        maxHeight: "100%",
        height: "100%",
        width: "100%",
        objectFit: "cover",
        borderRadius: 8
    }
}), { name: "DployCarInfoSummaryImageOrIcon" });
export function ImageOrIcon(props) {
    const { src, alt, className, icon, size = "large", bgcolor, iconColor } = props;
    const classes = useStyles(props);
    if (src) {
        return (_jsx("div", { className: clsx(className, classes.root, {
                [classes.rootSmall]: size === "small",
                [classes.rootLarge]: size === "large"
            }), children: _jsx("img", { className: classes.img, alt: alt, src: src }) }));
    }
    return (_jsx(Box, { className: clsx(className, classes.root, {
            [classes.rootSmall]: size === "small",
            [classes.rootLarge]: size === "large"
        }), bgcolor: bgcolor, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size === "small" ? 40 : 120, children: _jsx(Icon, { className: clsx(`fas fa-${icon}`, {
                [classes.iconSmall]: size === "small",
                [classes.iconLarge]: size === "large"
            }), color: iconColor }) }));
}
//# sourceMappingURL=ImageOrIcon.js.map